import { NgModule } from '@angular/core';

import { CenterColumnDirective } from './center-column.directive';
import { LeftColumnDirective } from './left-column.directive';
import { RightColumnDirective } from './right-column.directive';
import { CommonModule } from '@angular/common';

@NgModule({
   imports: [CommonModule],
   declarations: [LeftColumnDirective, CenterColumnDirective, RightColumnDirective],
   exports: [LeftColumnDirective, CenterColumnDirective, RightColumnDirective],
})
export class ColumnLayoutDirectivesModule {}
